<mat-dialog-content class="overflow-hidden" style="max-height:inherit">
    <div class="d-flex justify-content-between">
        <h5 class="fw-semibold">Energiedaten vom Gerät:&nbsp;{{ deviceName }}</h5>
        <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg" alt="close-modal-icon"
            (click)="onCloseDialogClicked()">
    </div>
    <div class="d-flex justify-content-center align-items-center mb-2">
        Von vor&nbsp;
        <input class="ms-1 me-1 form-control rounded-0 form-control-sm" style="width: 70px" type="number"
            [(ngModel)]="fromDate" (ngModelChange)="setFromDate(fromDate)" min="1" max="14">
            &nbsp;Tagen&nbsp;bis zu
        <input class="ms-1 me-1 form-control rounded-0 form-control-sm" style="width: 70px" type="number"
            [(ngModel)]="toDate" (ngModelChange)="setToDate(toDate)" min="0" max="13">
            &nbsp;Tagen
        <button (click)="removeData()" class="btn rounded-0 btn-outline-success ms-5   ms-sm-5 btn-sm"> Update
        </button>
    </div>
    <div class="d-flex flex-1 mh-100 h-100 flex-column justify-content-center align-content-center">
        <div class="p-5 overflow-scroll">
            <div *ngIf="isFuelcell" class="d-flex flex-column">
                <p class="fw-semibold text-secondary">Brennstoffzelle</p>
                <div class="chart-container d-flex justify-content-center overflow-scroll"
                    *ngIf="hasFuelCellData; else noFuelCellData">
                    <div class="chart-container w-100">
                        <canvas #measurementCanvas></canvas>
                        <canvas #efoyErrorCanvas *ngIf="hasFuelCellWarnErrorStatus; else noEFOYErrors"></canvas>
                    </div>
                </div>
            </div>

            <p class="fw-semibold text-secondary">Solarregler</p>
            <div class="chart-container d-flex justify-content-center overflow-scroll"
                *ngIf="hasSolarData; else noSolarData">
                <div class="chart-container w-100">
                    <canvas #voltageCanvas></canvas>
                    <canvas #currentCanvas></canvas>
                    <canvas #powerCanvas></canvas>
                    <canvas #solarErrorCanvas *ngIf="hasSolarWarnErrorStatus; else noSolarErrors"></canvas>
                </div>
            </div>
       </div> 
    </div>
</mat-dialog-content>

<ng-template #noFuelCellData>
    <p class="p-2 fw-semibold text-secondary">Für den gewählten Zeitraum liegen keine Daten der Brennstoffzelle vor</p>
</ng-template>
<ng-template #noSolarData>
    <p class="p-2 fw-semibold text-secondary">Für den gewählten Zeitraum liegen keine Daten des Solarreglers vor</p>
</ng-template>
<ng-template #noEFOYErrors>
    <p class="p-2 fw-semibold text-secondary">Es liegen keine Warn- oder Fehlerzustandsverläufe der Brennstoffzelle vor</p>
</ng-template>
<ng-template #noSolarErrors>
    <p class="p-2 fw-semibold text-secondary">Es liegen keine Warn- oder Fehlerzustandsverläufe des Solarreglers vor</p>
</ng-template>
<div mat-dialog-actions class="d-flex justify-content-between m-4">
    <button (click)="exportChart()" class="btn rounded-0 btn-outline-success btn-sm"> Export
    </button>
    <button (click)="onCloseDialogClicked()" class="btn rounded-0 btn-outline-danger btn-sm">
        Schließen
    </button>
</div>
